module.exports = __webpack_public_path__ + "static/media/dp_cut_point_channel.fe6e5ca0.webp";